import React, { useState } from "react";

import { Tabs } from "@performyard/py-components";

import { AsyncJobDownloadComponent } from "../../../../../../hooks/useAsyncJobDownload";

import BasePageTemplate from "../../../../../../pageTemplates/BasePageTemplate";
import { SurveyResultsHeader, SurveyResultsKPIs } from "./sections";
import Responses from "./tabs/Responses";
import Summary from "./tabs/Summary";

export function SurveyResults({ surveyId }: { surveyId: string }) {
	const [resultsTab, setResultsTab] = useState<"summary" | "responses">("summary");
	return (
		<BasePageTemplate title="Survey Results">
			<AsyncJobDownloadComponent jobName="survey-results-csv-export" />
			<div className="flex flex-col gap-5">
				{/* Header */}
				<div className="mb-1">
					<SurveyResultsHeader surveyId={surveyId} />
				</div>
				{/* KPIs */}
				<SurveyResultsKPIs surveyId={surveyId} />
				{/* Results Table */}
				<Tabs
					size="large"
					value={resultsTab}
					onValueChange={(value) => setResultsTab(value as "summary" | "responses")}
					tabs={[
						{
							value: "summary",
							label: "Summary",
							content: <Summary surveyId={surveyId} enableSuperRows />,
						},
						{
							value: "responses",
							label: "Responses",
							content: <Responses surveyId={surveyId} />,
						},
					]}
				/>
			</div>
		</BasePageTemplate>
	);
}
